<template>
  <el-form
    ref="shipperAccountForm"
    class="search-form"
    :inline="inlineForm"
    :model="form"
    :label-width="labelWidth"
  >
    <el-row :class="openMore ? 'search-bar-content-show' : 'search-bar-content-close'">
      <el-col
        v-for="item in field"
        :key="item.prop"
        :span="6"
      >
        <el-form-item :label="item.label">
          <component
            :is="item.formType"
            v-model="form[item.prop]"
            v-bind="item.Attributes"
            @change="searchData"
          >
            <template v-if="item.subFormType">
              <component
                :is="item.subFormType"
                v-for="option in item.options"
                :key="option.value"
                :label="option.label"
                :value="option.value"
              />
            </template>
          </component>
        </el-form-item>
      </el-col>
      <el-col :span="6">
        <div class="search-btns">
          <div class="moreData" @click="openMore = !openMore">
            {{ !openMore ? "展开筛选" : "收起筛选" }}
            <el-icon :class="openMore ? 'el-icon-caret-top' : 'el-icon-caret-bottom'" />
          </div>
          <div class="form-btns">
            <el-button
              class="form-btn"
              type="primary"
              @click.native.prevent="searchData"
            >
              查 询
            </el-button>
            <el-button class="form-btn" @click.native.prevent="resetData">
              重 置
            </el-button>
          </div>
        </div>
      </el-col>
    </el-row>
  </el-form>
</template>
<script>

export default {
  props: {
    field: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      inlineForm: true,
      form: {},
      labelWidth: '100px',
      openMore: false,
    };
  },
  methods: {
    searchData() {
      this.$emit('queryData', this.form);
    },
    resetFormInfo() {
      this.form = {};
    },
    resetData() {
      this.resetFormInfo();
      this.$emit('resetData');
    },
  },
};
</script>
<style lang="scss" scoped>
.search-btns {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  .moreData {
    font-size: 12px;
    color: #606266;
    margin-right: 28px;
    &:hover {
      cursor: pointer;
    }
    [class*=" el-icon-"],
    [class^="el-icon-"] {
      color: #06b880 !important;
      font-family: "element-icons" !important;
    }
  }
}
.search-form ::v-deep {
  .el-col {
    margin: 12px 0;
    .el-form-item {
      width: 100%;
      display: flex;
      margin: 0;
      .el-form-item__label {
        white-space: nowrap;
        overflow: hidden;
      }
      .el-form-item__content {
        width: calc(100% - 128px);
        .el-select,
        .el-date-editor  {
          width: 100%;
        }
      }
    }
  }
}
.search-bar-content-close::v-deep {
  .el-col {
    display: none !important;
  }
  .el-col:nth-child(1) {
    display: block !important;
  }
  .el-col:nth-child(2) {
    display: block !important;
  }
  .el-col:nth-child(3) {
    display: block !important;
  }
  .el-col:nth-last-child(1) {
    float: right !important;
    display: block !important;
  }
}
.search-bar-content-show::v-deep {
  .el-col:nth-last-child(1) {
    float: right !important;
  }
}
</style>
